module.exports = __webpack_public_path__ + "img/es-ct.d56ad90c.svg";